<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>Upload</h3>
    </div>

    <div class="box">
      @if (loading) {
        <div class="loading-container">
          <app-loading-screen
            [local]="true"
            [contrast]="true"></app-loading-screen>
        </div>
      }
      <!-- <p>Please pick a file</p> -->
      @if (!loading) {
        <div class="group">
          <div class="flex-container">
            @if (entities.length) {
              <coin-dropdown
                style="margin-left: 20px"
                label="File Type"
                [items]="entities"
                [shadow]="true"
                [displayFn]="dropdownDisplayFn"
                [disabled]="uploading"
                (selectionChange)="applySelectionChange($event)"></coin-dropdown>
            }
          </div>
          <div class="flex-container">
            @if (importFileName) {
              <coin-v2-text-input
                style="margin-left: 20px"
                [label]="'Selected File'"
                [disabled]="true"
                [(ngModel)]="importFileName"></coin-v2-text-input>
            }
            <ng-template #buttonsRightTemplate>
              <coin-v2-button
                [type]="'primary'"
                [icon]="'upload'"
                [iconPos]="'right'"
                [text]="importFileName ? 'Change File' : 'Select File'"
                [disabled]="!selectedFileTypePrefix || uploading"
                (click)="fileInput.click()"></coin-v2-button>
              <input
                #fileInput
                type="file"
                style="display: none"
                (change)="onFileSelected($event)" />
            </ng-template>
            <importer-button-footer
              style="margin: 0"
              [buttonsRightTemplate]="buttonsRightTemplate"></importer-button-footer>
          </div>
          @if (importFileName) {
            <div class="group">
              <p class="flex-container">
                <coin-v2-checkbox
                  matTooltip="On full load all objects which are not included in upload will be collected for manual delete from current base"
                  [ngModel]="fullLoadCheckBoxState"
                  (ngModelChange)="toggleFullLoad($event)"></coin-v2-checkbox>
                Full Load
              </p>
            </div>
          }
          @if (!loading) {
            <mat-progress-bar
              [color]="progressBarColor"
              [mode]="progressMode"
              [value]="progressValue"></mat-progress-bar>
          }
          <div class="buttons">
            <coin-v2-button
              [type]="'secondary'"
              [icon]="'close'"
              [iconPos]="'right'"
              [text]="uploading ? 'Cancel' : 'Close'"
              (click)="close()"></coin-v2-button>

            <coin-v2-button
              [type]="'primary'"
              [icon]="'upload'"
              [iconPos]="'right'"
              [text]="uploading ? 'Uploading' : 'Upload'"
              [disabled]="!importFile || !selectedFileTypePrefix || uploading"
              (click)="save()"></coin-v2-button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
